import React from 'react';
import { useState } from 'react';

import styles from './SegmentedMenu.module.scss';
import { Props } from './SegmentedMenu.types';
import SegmentedMenuItem from './SegmentedMenuItem';
import { BoundingRect } from './SegmentedMenuItem/SegmentedMenuItem.types';

function SegmentedMenu<T>({ controls, selected, onSelectionChange, keyValueExtractor }: Props<T>) {
  const [boundingRect, setBoundingRect] = useState<BoundingRect>();

  return (
    <>
      <div className={styles.tabMenuContainer}>
        {controls.map(control => {
          const { key, value } = keyValueExtractor(control);
          return (
            <SegmentedMenuItem
              label={value}
              isSelected={selected === key}
              key={key}
              onSelect={() => onSelectionChange(control)}
              setBoundingRect={setBoundingRect}
            />
          );
        })}
      </div>
      <div
        className={styles.bottomBar}
        style={{
          display: boundingRect === undefined ? 'none' : 'inline-block',
          width: boundingRect?.width ?? 0,
          left: boundingRect?.left ?? 0,
          top: boundingRect?.bottom ? boundingRect?.bottom + 9 : 0,
        }}
      />
      <div className={styles.horizontalSeparator} />
    </>
  );
}

export default SegmentedMenu;
